<template>
    <div class="recommendations">
        <div class="recommendations__navigation" v-if="showControls">
            <button @click="prev" class="prev"></button>
            <button @click="next" class="next"></button>
        </div>
        <slot name="title"></slot>
        <div v-swiper:swiper="swiperOptions" :key="swiperOptions.loop">
            <div class="swiper-wrapper">
                <slot name="slides"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import {directive} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css'

export default {
    name: 'RecommendationsList',
    props: {
        count: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination',
                },
                autoHeight: true,
                calculateHeight: true,
                loop: true,
                slidesPerView: 1,
                spaceBetween: 20,
                watchOverflow: true,
            },
            showControls: false,
        }
    },
    methods: {
        prev() {
            this.swiper.slidePrev();
        },
        next() {
            this.swiper.slideNext();
        },
    },
    directives: {
        swiper: directive,
    },
    mounted() {
        if (+this.count > 1) {
            this.showControls = true;
        } else {
            this.swiperOptions.loop = false;
        }
    },
}
</script>
<style lang="scss">
@import "../../scss/base/include";

.recommendations {
    background: linear-gradient(0deg, #5BC6C1, #5BC6C1), linear-gradient(0deg, #78D4D1, #78D4D1), linear-gradient(254.13deg, rgba(28, 178, 190, 0.51) 14.55%, #00ABAA 52.2%);
    color: $white-true;
    padding: 59px 130px 30px 27px;
    border-radius: 20px;
    height: 100%;
    position: relative;
    @include tablet {
        padding: 87px 27px 30px 27px;
    }
    @include mobile {
        padding: 87px 20px 48px 17px;
    }

    &__title {
        font-weight: 500;
        font-size: 24px;
        line-height: 29px;
        margin: 0 0 28px;
        @include tablet {
            font-size: 18px;
            line-height: 22px;
            margin: 0 0 23px;
        }
        @include mobile {
            margin: 0 0 10px;
        }
    }

    &__navigation {
        position: absolute;
        top: 19px;
        right: 19px;

        button {
            background-color: transparent;
            width: 39px;
            height: 39px;
            background-image: url(/local/templates/pnd/src/assets/i2/arrow-white.svg);
            background-position: 58% 50%;
            background-repeat: no-repeat;
            background-size: 9px auto;
            border: solid 1px rgba($color: $white-true, $alpha: .3);
            outline: none;
            border-radius: 50%;
            cursor: pointer;

            &:disabled {
                cursor: default;
                opacity: 0.3;
                border-color: $border;
            }

            &.prev {
                transform: scale(-1, 1);
            }

            &.next {
                margin-left: 8px;
            }
        }
    }

    &__item {
        font-size: 18px;
        line-height: 27px;
        @include tablet {
            font-size: 16px;
            line-height: 150%;
        }

        &-title {
            font-weight: bold;
        }
    }
}
</style>
